import { apiClient } from './apiClient';
import { CompanySetting } from '../types/CompanySetting';
import { LicenseStatus } from '../types/LicenseStatus';
import { UserProfile } from '../types/UserProfile';

export async function fetchProfile(): Promise<UserProfile> {
  const response = await apiClient.get<UserProfile>('/v1/me/profile');
  return response.data;
}

export async function updateProfile(payload: {
  nickName: string;
  profilePhotoBase64: string;
}): Promise<UserProfile> {
  const response = await apiClient.put<UserProfile>('/v1/me/profile', payload);
  return response.data;
}

export async function fetchLicenseStatus(): Promise<LicenseStatus> {
  const response = await apiClient.get<LicenseStatus>('/v1/license/status');
  return response.data;
}

export async function fetchCompanySettings(): Promise<CompanySetting> {
  const response = await apiClient.get<CompanySetting>('/v1/company-settings/current');
  return response.data;
}

export async function updateCompanySettings(payload: {
  language?: string;
  appTitle?: string;
  primaryColor?: string;
  secondaryColor?: string;
  timezone?: string;
  dateFormat?: string;
}): Promise<CompanySetting> {
  const response = await apiClient.put<CompanySetting>('/v1/company-settings/current', payload);
  return response.data;
}

export async function fetchSystemVersion(): Promise<{ version: string }> {
  const response = await apiClient.get<{ version: string }>('/v1/system-version');
  return response.data;
}
